import React from "react"
import { Link } from "gatsby"
import { StaticQuery, graphql } from "gatsby"
import PostCard from "./post-card"
import ActionBox from "./action-box"
import NotesBox from "./notes-box"

const Home = () => (
  <StaticQuery
    query={graphql`
      query RecentPostsForHomePage {
        allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
          edges {
            node {
              fields {
                slug
              }
              excerpt(pruneLength: 100)
              frontmatter {
                template
                date(formatString: "MMMM Do YYYY")
                title
                permalink
                image {
                  childImageSharp {
                    fluid(maxWidth: 786) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const edges = data.allMarkdownRemark.edges
      return (
        <div>
          <div className="home text-center bg-grey p-4 mb-4">
            <div className="h1 text-primary-color m-5 font-weight-bold">
              Welcome to FundaBasic{" "}
            </div>
            <div className="h4 w-75 mx-auto line-height-2">
              <p>Comprehensive learning resource for competitive exams.</p>
              <p>No boring theory. Or pointless explanations.</p>
              <p>Simplified guides and Practice Papers with clear examples.</p>
            </div>
            <div className="my-4 h5">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="http://eepurl.com/c0yzRr"
              >
                <button className="appearnce-none p-3 action-button">
                  Yes, send me updates!
                </button>
              </a>
              <Link to="/blog">
                <button className="appearnce-none p-3 m-4 button-grey">
                  Take me to the blog!
                </button>
              </Link>
            </div>
          </div>

          {/* <h2 className="mt-4">Sample Action box</h2>
          <ActionBox title="Do you Know?" paragraph="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum." buttonLabel="Show More >" buttonLink="http://google.com" buttonType="action-button external-link"></ActionBox>

          <h2>Sample Tooltip boxes (Notes boxes)</h2>
          <NotesBox title="Alert:" paragraph="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum." noteType="bg-danger text-white"></NotesBox>

          <NotesBox title="Note:" paragraph="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum." noteType="bg-light"></NotesBox>

          <NotesBox title="Success:" paragraph="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum." noteType="bg-success text-white"></NotesBox>
 */}
          <h2>Recent posts</h2>
          <div className="row my-3">
            {edges.map(({ node }, i) => {
              if (node.frontmatter.template !== "info") {
                return <PostCard key={Math.random()} node={node} />
              }
            })}
          </div>
        </div>
      )
    }}
  />
)

export default Home
